import api from "./api";

const RouteAPI = {
    getById: (id) => api.get(`/routes/details/${id}`),
    update: (params) => api.post(`/routes/update`, params),
};

export default RouteAPI;